import React from 'react';
import { useDispatch } from 'react-redux';

import { getNonFalsyUrlSearchParams } from '@gumtree/shared/src/util/url-params';
import { redirectToUrl } from '@gumtree/shared/src/util/browser-service';

import type { SrpUseDispatch } from '../../reducers';
import type { Filter, FiltersDictionary, FilterKey } from '../../types';
import RangeFilter from '../filters/range-filter';
import { StyledBlockTitle, StyledRange, StyledUpdateButton } from './range-filter-frame.style';
import { getRangeFilterValues } from '../filters/range-filter/util';
import { trackGA4FiltersDiffThunk } from '../../reducers/current-filter-states';

export default function RangeFilterFrame({
    currentFilterStates,
    filtersDictionary,
    filterKey,
}: {
    currentFilterStates: Filter;
    filtersDictionary: FiltersDictionary;
    filterKey: FilterKey;
}) {
    const dispatch = useDispatch() as SrpUseDispatch;

    try {
        const { minKey, maxKey, minValues, maxValues, label, initialMinValue, initialMaxValue } =
            getRangeFilterValues(filtersDictionary[filterKey]);

        const minCount = currentFilterStates[minKey] as string | undefined;
        const maxCount = currentFilterStates[maxKey] as string | undefined;

        const handleRunFilter = () => {
            const url = getNonFalsyUrlSearchParams(currentFilterStates);

            dispatch(trackGA4FiltersDiffThunk());
            redirectToUrl(`/search?${url.toString()}`);
        };

        return (
            <>
                <StyledBlockTitle>{label}</StyledBlockTitle>
                <StyledRange>
                    <RangeFilter
                        filterKey={filterKey}
                        initialMinValue={initialMinValue}
                        initialMaxValue={initialMaxValue}
                        maxValues={maxValues}
                        maxKey={maxKey}
                        minValues={minValues}
                        minKey={minKey}
                        minCount={minCount || initialMinValue}
                        maxCount={maxCount || initialMaxValue}
                        isStateful={false}
                    />
                    <StyledUpdateButton
                        display="primary"
                        label="Update"
                        onClick={handleRunFilter}
                    />
                </StyledRange>
            </>
        );
    } catch (_error) {
        return <></>;
    }
}
